import * as React from 'react';
import { FunctionComponent, ReactElement } from 'react';

import { BaseButton } from '../../../../../../shared/components/base-button/base-button';
import { AddOrRemoveButtonProps } from '../../models/add-or-remove-button-props.model';

export const AddOrRemoveButton: FunctionComponent<AddOrRemoveButtonProps> = (
  props: AddOrRemoveButtonProps
): ReactElement => {
  const { onActionButton, buttonIcon } = props;

  return (
    <BaseButton onClick={onActionButton} className="btn-filter-array">
      {buttonIcon}
    </BaseButton>
  );
};
